class RecurringProphyQuestionnaire {
  constructor (molecule, dosage) {
    this.id = 'recurringProphy' + molecule
    this.title = 'Repeat Prophy Question'
    this.theme = {
      'href': 'https://api.typeform.com/themes/G69ViG'
    }
    this.workspace = {
      'href': 'https://api.typeform.com/workspaces/11680930'
    }
    this.settings = {
      'is_public': true,
      'is_trial': false,
      'language': 'en',
      'progress_bar': 'percentage',
      'show_progress_bar': true,
      'show_typeform_branding': false,
      'meta': {
        'allow_indexing': false
      }
    }
    this.thankyou_screens = [
      {
        'ref': 'default_tys',
        'title': 'Done! Your information was sent perfectly.',
        'properties': {
          'show_button': true,
          'share_icons': false
        }
      }
    ]

    let currentDosage = [
      {
        'id': 'nTYQiBWW3Og8',
        'ref': '49c932e6-c897-45d0-a775-eda12c7d5447',
        'label': dosage[0]
      },
      {
        'id': 'vmOidumwPe9D',
        'ref': '9c595f2d-77a4-427d-b31f-2bdc16895223',
        'label': dosage[1]
      }
    ]

    let lastDosage = [
      {
        'id': 'nTYQiBWW3Og8',
        'ref': '49c932e6-c897-45d0-a775-eda12c7d5447',
        'label': dosage[0]
      },
      {
        'id': 'vmOidumwPe9D',
        'ref': '9c595f2d-77a4-427d-b31f-2bdc16895223',
        'label': dosage[1]
      }
    ]

    if (dosage[2]) {
      currentDosage.push({
        'id': 'xwo9HSgFZdy4',
        'ref': 'f24f57a1-6fc2-4447-9e8f-19744e452cae',
        'label': dosage[2]
      })
      lastDosage.push({
        'id': 'RGYPXWN71mIG',
        'ref': 'f62e35a2-8b77-43eb-8a3f-ac8bf4585f7a',
        'label': dosage[2]
      })
    }

    this.fields = [
      {
        'id': 'o9QHHxd23B61',
        'title': 'Are you still on {{hidden:prophy}} treatment between {{calculated:humanStartDate}} and {{calculated:humanEndDate}}?',
        'ref': '22e5c0f3-a6eb-46fb-8091-e8cce099b9be',
        'properties': {
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': false,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'w7Kfb7JpOKfj',
              'ref': '49c932e6-c897-45d0-a775-eda12c7d5447',
              'label': 'Yes'
            },
            {
              'id': 'MvdCEwCtsnHo',
              'ref': '73319df1-9ef9-4fa0-b8a1-248a1f2906ca',
              'label': 'No'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'OT0Yw5WGgz6u',
        'title': 'What is your current dosage of {{hidden:prophy}} ?',
        'ref': '73e6dd31-100d-4e29-8c2c-d36b1d15b4d1',
        'properties': {
          'description': 'Previous recorded dosage: {{hidden:dosage}}',
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': currentDosage
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'BygenZejjmgI',
        'title': 'How many <b>migraine days</b> did you experience between {{calculated:humanStartDate}} and {{calculated:humanEndDate}}?',
        'ref': '1532e8a7-415f-4729-8ded-2096a1b62437',
        'properties': {
          'description': 'Migraine days recorded: {{calculated:hintMigDays}}'
        },
        'validations': {
          'required': true,
          'max_value': 30
        },
        'type': 'number'
      },
      {
        'id': 'S9vddWNdHNC5',
        'title': 'How <b>many days of acute migraine medication</b> did you experience between {{calculated:humanStartDate}} and {{calculated:humanEndDate}}?',
        'ref': 'f76f5eb5-7e0e-41eb-b268-688483d7baf9',
        'properties': {
          'description': 'Estimated acute medication days: {{calculated:hintMedDays}}'
        },
        'validations': {
          'required': true,
          'max_value': 30
        },
        'type': 'number'
      },
      {
        'id': 'QM0aOxzzf2E0',
        'title': 'How would you rate the <b>impact of migraines on your work/school/housework activities</b>?',
        'ref': '1ebb17ab-abbf-4f3f-b611-e7a60c1f5d5a',
        'properties': {
          'description': 'Time Period: {{calculated:humanStartDate}} to {{calculated:humanEndDate}}',
          'steps': 6,
          'start_at_one': false,
          'labels': {
            'left': 'Not at all',
            'right': 'Severely affected'
          }
        },
        'validations': {
          'required': false
        },
        'type': 'opinion_scale'
      },
      {
        'id': 'VKMOg3H7gJbf',
        'title': 'How would you rate the <b>impact of migraines on your social activities</b>?',
        'ref': 'a52c9896-c0a6-4eb9-b24b-599a8de6b4a1',
        'properties': {
          'description': 'Time Period: {{calculated:humanStartDate}} to {{calculated:humanEndDate}}',
          'steps': 6,
          'start_at_one': false,
          'labels': {
            'left': 'Not at all',
            'right': 'Severely affected'
          }
        },
        'validations': {
          'required': false
        },
        'type': 'opinion_scale'
      },
      {
        'id': 'EkJcexrT5Zkq',
        'title': 'Did you <b>experience any side effects</b> after taking {{hidden:prophy}}?',
        'ref': 'c8cbbe2c-0660-40f0-8fc5-2f9b842dbc29',
        'properties': {
          'description': 'Time Period: {{calculated:humanStartDate}} to {{calculated:humanEndDate}}',
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': false,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'MR0xImq3uPRI',
              'ref': '65ca9a4f-8c12-40d0-aed7-c7710613819b',
              'label': 'None'
            },
            {
              'id': 'nVY241lrEj0A',
              'ref': '1ea3131f-cf3b-4b26-8b17-6927603d5ce7',
              'label': 'Mild side effects'
            },
            {
              'id': 'Kb4x8xXD02cL',
              'ref': '913003da-042c-44ab-b1a0-83d7a787e10f',
              'label': 'Moderate side effects'
            },
            {
              'id': 'RMExV0aQr6WZ',
              'ref': '09d91f20-900d-4e75-9243-f701d5d61103',
              'label': 'Severe side effects'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'GVGSEzRFV13E',
        'title': 'Did you experience <b>reduction of any migraine symptoms</b>?',
        'ref': '9bcdaecc-360e-43d5-999c-739ebd56e04c',
        'properties': {
          'description': 'Time Period: {{calculated:humanStartDate}} to {{calculated:humanEndDate}}',
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': false,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'UWwBHCKnbi4e',
              'ref': '54c932e6-c897-45d0-a775-eda12c7d5411',
              'label': 'Yes'
            },
            {
              'id': 'zIQJTjb5Q02G',
              'ref': '84219df1-9ef9-4fa0-b8a1-248a1f2906bb',
              'label': 'No'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'K3EFcTZHnqtk',
        'title': 'Which of your migraines symptoms were reduced?',
        'ref': '9c20dfa6-581d-4307-8c6c-12938f6fedee',
        'properties': {
          'description': 'Time Period: {{calculated:humanStartDate}} to {{calculated:humanEndDate}}',
          'randomize': true,
          'allow_multiple_selection': true,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'B9SDMIXnVBDE',
              'ref': '334d2050-bbd2-4691-ae10-d9623abc605f',
              'label': 'Pain'
            },
            {
              'id': 'KrBr5WtUTpKY',
              'ref': '26929b88-e958-4caa-95b2-aedbda1a6f5a',
              'label': 'Light-sensitivity'
            },
            {
              'id': 'rJfx8LszSVXY',
              'ref': '0fc82809-f124-4ae4-b7f5-aa98ff2313ca',
              'label': 'Fatigue'
            },
            {
              'id': 'wyOckmjIOStp',
              'ref': 'f7a3ff35-4f24-4a8b-b73f-4b892ca10bc1',
              'label': 'Depression'
            },
            {
              'id': 'FP6oEa9UY826',
              'ref': '1596fdc4-4043-44ae-b28e-4be95d311b21',
              'label': 'Anxiety'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'LOGtRTTE7dBd',
        'title': 'How much did {{hidden:prophy}} <b>help your most bothersome migraine symptom</b>?',
        'ref': 'c3fa2be4-9bdb-42e0-8745-30b031d2e452',
        'properties': {
          'description': 'Time Period: {{calculated:humanStartDate}} to {{calculated:humanEndDate}}',
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': false,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'YrKubyHyGBDN',
              'ref': '7ab00301-1c01-4749-bb0e-8752f3dfc6ef',
              'label': 'Not at all'
            },
            {
              'id': 'F3tndjFTQmul',
              'ref': '5fb5fddd-43ef-4aa5-bd99-b2e268f58630',
              'label': 'Somewhat helpful'
            },
            {
              'id': 'kVW2qFmiUpe1',
              'ref': '36d63254-95e7-409d-9898-9dd4bfab962b',
              'label': 'Very helpful'
            },
            {
              'id': 'fFTnTioa4u5m',
              'ref': 'd21e0db6-f6f4-4db2-abd4-1a5c08fcb980',
              'label': "I don't know"
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'S9yoURePh4cQ',
        'title': 'What is the dosage of your last {{hidden:prophy}} intake?',
        'ref': '12ed40ec-c8f9-490d-8e9f-1a8580cb6c56',
        'properties': {
          'description': 'Previous recorded dosage: {{hidden:dosage}}',
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': lastDosage
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'UFGJ9JBN0uE5',
        'title': 'When did you last take {{hidden:prophy}}?',
        'ref': '9874f185-54ec-4207-bb82-783369a713b1',
        'properties': {
          'structure': 'MMDDYYYY',
          'separator': '/'
        },
        'validations': {
          'required': true,
          'end_date': {
            'type': 'today'
          }
        },
        'type': 'date'
      },
      {
        'id': 'SdbYJ2llLcvZ',
        'title': 'Why did you/your doctor stop {{hidden:prophy}} ?',
        'ref': '0064fce5-3fb2-4e3c-a80d-39dd733b8cd9',
        'properties': {
          'randomize': true,
          'allow_multiple_selection': true,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'sutZgIgfk44P',
              'ref': 'd4929552-33c6-41bd-9fb2-67de86ee68c9',
              'label': 'It did not help'
            },
            {
              'id': 'p4y2v9h5KDun',
              'ref': '46dc4887-8095-4521-b544-6b5d3eb0d554',
              'label': 'Disturbing side effects'
            },
            {
              'id': 'NcFQrw28vTSq',
              'ref': 'f945d558-405e-4fc0-b68b-9f18171c9984',
              'label': 'It used to help but is less helpful now'
            },
            {
              'id': 'MXXBaEpUrfaF',
              'ref': '6002d27a-737b-4dea-9f12-50277122901d',
              'label': 'Fear of long term side effects'
            },
            {
              'id': 'CSc2sxmIxwbH',
              'ref': 'b9f4bdd3-6d5c-4021-9b44-b40565fe4f4a',
              'label': 'Too expensive'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      }
    ]

    this.hidden = [
      'prophy',
      'dosage',
      'recurring_order',
      'start_date'
    ]

    this.logic = [
      {
        'type': 'field',
        'ref': '9bcdaecc-360e-43d5-999c-739ebd56e04c',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '9c20dfa6-581d-4307-8c6c-12938f6fedee'
              }
            },
            'condition': {
              'op': 'is',
              'vars': [
                {
                  'type': 'field',
                  'value': '9bcdaecc-360e-43d5-999c-739ebd56e04c'
                },
                {
                  'type': 'choice',
                  'value': '54c932e6-c897-45d0-a775-eda12c7d5411'
                }
              ]
            }
          },
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '9c20dfa6-581d-4307-8c6c-12938f6fedee'
              }
            },
            'condition': {
              'op': 'greater_than',
              'vars': [
                {
                  'type': 'field',
                  'value': 'f76f5eb5-7e0e-41eb-b268-688483d7baf9'
                },
                {
                  'type': 'constant',
                  'value': 30
                }
              ]
            }
          }
        ]
      },
      {
        'type': 'field',
        'ref': '0064fce5-3fb2-4e3c-a80d-39dd733b8cd9',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'thankyou',
                'value': 'default_tys'
              }
            },
            'condition': {
              'op': 'is',
              'vars': [
                {
                  'type': 'field',
                  'value': 'c8cbbe2c-0660-40f0-8fc5-2f9b842dbc29'
                },
                {
                  'type': 'choice',
                  'value': '65ca9a4f-8c12-40d0-aed7-c7710613819b'
                }
              ]
            }
          },
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'thankyou',
                'value': 'default_tys'
              }
            },
            'condition': {
              'op': 'is_not',
              'vars': [
                {
                  'type': 'field',
                  'value': '9c20dfa6-581d-4307-8c6c-12938f6fedee'
                },
                {
                  'type': 'choice',
                  'value': '0fc82809-f124-4ae4-b7f5-aa98ff2313ca'
                }
              ]
            }
          },
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'thankyou',
                'value': 'default_tys'
              }
            },
            'condition': {
              'op': 'always',
              'vars': {
              }
            }
          }
        ]
      },
      {
        'type': 'field',
        'ref': '22e5c0f3-a6eb-46fb-8091-e8cce099b9be',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '73e6dd31-100d-4e29-8c2c-d36b1d15b4d1'
              }
            },
            'condition': {
              'op': 'is',
              'vars': [
                {
                  'type': 'field',
                  'value': '22e5c0f3-a6eb-46fb-8091-e8cce099b9be'
                },
                {
                  'type': 'choice',
                  'value': '49c932e6-c897-45d0-a775-eda12c7d5447'
                }
              ]
            }
          },
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '12ed40ec-c8f9-490d-8e9f-1a8580cb6c56'
              }
            },
            'condition': {
              'op': 'always',
              'vars': {
              }
            }
          }
        ]
      },
      {
        'type': 'field',
        'ref': 'c3fa2be4-9bdb-42e0-8745-30b031d2e452',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'thankyou',
                'value': 'default_tys'
              }
            },
            'condition': {
              'op': 'always',
              'vars': {
              }
            }
          }
        ]
      },
      {
        'type': 'field',
        'ref': '73e6dd31-100d-4e29-8c2c-d36b1d15b4d1',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '1532e8a7-415f-4729-8ded-2096a1b62437'
              }
            },
            'condition': {
              'op': 'always',
              'vars': {
              }
            }
          }
        ]
      }
    ]

    this._links = {
      'display': 'https://healint.typeform.com/to/dUeK7M'
    }
  }
}

export default RecurringProphyQuestionnaire



// WEBPACK FOOTER //
// ./src/store/questionnaires/questionnaireConfig/RecurringProphyQuestionnaire.js